var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackageHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trailing-icon",
    clipPath: "url(#packageHistory)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5 7.2H15C15 5.432 13.6575 4 12 4C10.3425 4 9 5.432 9 7.2H7.5C6.675 7.2 6 7.92 6 8.8V18.4C6 19.28 6.675 20 7.5 20H16.5C17.325 20 18 19.28 18 18.4V8.8C18 7.92 17.325 7.2 16.5 7.2ZM12 5.6C12.825 5.6 13.5 6.32 13.5 7.2H10.5C10.5 6.32 11.175 5.6 12 5.6ZM16.5 18.4H7.5V8.8H9V10.4C9 10.84 9.3375 11.2 9.75 11.2C10.1625 11.2 10.5 10.84 10.5 10.4V8.8H13.5V10.4C13.5 10.84 13.8375 11.2 14.25 11.2C14.6625 11.2 15 10.84 15 10.4V8.8H16.5V18.4Z",
    fill: "#295BB7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "packageHistory"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageHistory);
export default __webpack_public_path__ + "static/media/packageHistory.c43c1d28f2c9472160dc39d38c0f9b11.svg";
export { ForwardRef as ReactComponent };